module.exports = __webpack_public_path__ + "static/img/bg-en.486ead2d.png";